// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__fxIGG","backButtonLabel":"BackButton_backButtonLabel__k0i6D"};